<template>
  <router-link
    :to="to"
    :class="classes"
    :tag="tag"
    :title="title"
  >
    <slot>{{ displayText }}</slot>
    <v-icon
      v-if="showIcon"
      class="cross-page-link-icon"
    >
      mdi-launch
    </v-icon>
  </router-link>
</template>

<script>
export default {
  name: 'CrossPageLink',
  props: {
    to: {
      type: [String, Object],
      required: true
    },
    displayText: {
      type: [String, Number],
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    classes: {
      type: [String, Object, Array],
      default: ''
    },
    tag: {
      type: String,
      default: undefined
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
  .cross-page-link-icon {
    color: inherit !important;
    font-size: 10px !important;
  }
</style>
